import './assets/report-action-guide.scss';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { GuestFreeUsageApi } from './apis/guest-free-usage-api';
import { GuestFreeUsageApiImpl } from './apis/impls/guest-free-usage-api';
import { GuestFreeUsageService } from './services/guest-free-usage-service';
import { GuestFreeUsageServiceImpl } from './services/impls/guest-free-usage-service';
import { GuestFreeFirstRunPromptService } from './services/guest-free-first-run-prompt-service';
import { GuestFreeFirstRunPromptServiceImpl } from './services/impls/guest-free-first-run-prompt-service';
import { OnboardingActionGuideRuntime } from './services/onboarding-action-guide-runtime';
import { OnboardingActionGuideRuntimeImpl } from './services/impls/onboarding-action-guide-runtime';
import { OnboardingActionGuideService } from './services/onboarding-action-guide-service';
import { OnboardingActionGuideServiceImpl } from './services/impls/onboarding-action-guide-service';
import { OnboardingEligibilityService } from './services/onboarding-eligibility-service';
import { OnboardingEligibilityServiceImpl } from './services/impls/onboarding-eligibility-service';
import { OnboardingBrowserRuntime } from './services/onboarding-browser-runtime';
import { OnboardingBrowserRuntimeImpl } from './services/impls/onboarding-browser-runtime';
import { OnboardingInputExampleGuidePresenter } from './services/onboarding-input-example-guide-presenter';
import { OnboardingInputExampleGuidePresenterImpl } from './services/impls/onboarding-input-example-guide-presenter';
import { ReportActionGuideBubblePresenter } from './services/report-action-guide-bubble-presenter';
import { ReportActionGuideBubblePresenterImpl } from './services/impls/report-action-guide-bubble-presenter';

/** 注册首次引导公共 API 和 service。 */
export const onboardingCommonModule = (bind: interfaces.Bind) => {
    bind(GuestFreeUsageApi).to(GuestFreeUsageApiImpl);
    bind(GuestFreeUsageService).to(GuestFreeUsageServiceImpl);
    bind(GuestFreeFirstRunPromptService).to(GuestFreeFirstRunPromptServiceImpl).inTransientScope();
    bind(OnboardingActionGuideRuntime).to(OnboardingActionGuideRuntimeImpl);
    bind(OnboardingActionGuideService).to(OnboardingActionGuideServiceImpl);
    bind(OnboardingEligibilityService).to(OnboardingEligibilityServiceImpl);
    bind(OnboardingBrowserRuntime).to(OnboardingBrowserRuntimeImpl);
    bind(OnboardingInputExampleGuidePresenter).to(OnboardingInputExampleGuidePresenterImpl);
    bind(ReportActionGuideBubblePresenter).to(ReportActionGuideBubblePresenterImpl);
};

export { GuestFreeUsageApi } from './apis/guest-free-usage-api';
export { GuestFreeUsageApiImpl } from './apis/impls/guest-free-usage-api';
export { GuestFreeUsageService } from './services/guest-free-usage-service';
export { GuestFreeUsageServiceImpl } from './services/impls/guest-free-usage-service';
export { GuestFreeFirstRunPromptService } from './services/guest-free-first-run-prompt-service';
export { GuestFreeFirstRunPromptServiceImpl } from './services/impls/guest-free-first-run-prompt-service';
export { OnboardingActionGuideRuntime } from './services/onboarding-action-guide-runtime';
export { OnboardingActionGuideRuntimeImpl } from './services/impls/onboarding-action-guide-runtime';
export { OnboardingActionGuideService } from './services/onboarding-action-guide-service';
export { OnboardingActionGuideServiceImpl } from './services/impls/onboarding-action-guide-service';
export { OnboardingEligibilityService } from './services/onboarding-eligibility-service';
export { OnboardingEligibilityServiceImpl } from './services/impls/onboarding-eligibility-service';
export { OnboardingBrowserRuntime } from './services/onboarding-browser-runtime';
export { OnboardingBrowserRuntimeImpl } from './services/impls/onboarding-browser-runtime';
export { OnboardingInputExampleGuidePresenter } from './services/onboarding-input-example-guide-presenter';
export { OnboardingInputExampleGuidePresenterImpl } from './services/impls/onboarding-input-example-guide-presenter';
export { ReportActionGuideBubblePresenter } from './services/report-action-guide-bubble-presenter';
export { ReportActionGuideBubblePresenterImpl } from './services/impls/report-action-guide-bubble-presenter';
export { registerOnboardingLocaleMessages } from './utils/onboarding-locale';
export { createReportCanvasPlacementTracker } from './utils/report-canvas-placement';
export { hasSeenOnboarding, markOnboardingSeen } from './utils/onboarding-storage';
export type {
    ReportCanvasPlacement,
    ReportCanvasPlacementTracker,
} from './utils/report-canvas-placement';
export type {
    GuestFreeFirstRunPromptResult,
    GuestFreeFirstRunPromptShowOptions,
} from './services/guest-free-first-run-prompt-service';
export type {
    OnboardingInputExampleGuideMode,
    OnboardingInputExampleGuideShowOptions,
} from './services/onboarding-input-example-guide-presenter';
export type {
    ReportActionGuideBubbleShowOptions,
} from './services/report-action-guide-bubble-presenter';
